import React from 'react';
import SpeechBubble from './SpeechBubble';

function ToolTipIcon(props) {
  return (
    <div className="tooltip-container">
      {props.showToolTip && (
        <SpeechBubble
          textToDisplay={props.tooltip}
          bottom="28px"
          right="-126px"
          padding="2px"
        />
      )}
      <svg
        data-text-color="black"
        data-background-color="white"
        data-border
        aria-label={props.ariaLabel || ''}
        data-border-color="black"
        data-class="tooltip"
        data-effect="solid"
        data-tip={props.tooltip}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="18px"
        height="18px"
        viewBox="0 0 1000 1000"
        role="img"
      >
        <title>Tooltip Icon</title>
        <g>
          <path
            fill={props.color}
            d="M500.07,0.14c-276.14,0-500,223.86-500,500s223.86,500,500,500s500-223.86,500-500
            S776.21,0.14,500.07,0.14z M500.07,221.92c46.76,0,84.67,37.91,84.67,84.67s-37.91,84.67-84.67,84.67
            c-46.76,0-84.67-37.91-84.67-84.67v0l0,0C415.4,259.83,453.31,221.92,500.07,221.92z M613.02,734.03
            c0,13.38-10.84,24.22-24.22,24.22H411.18c-13.38,0-24.22-10.84-24.22-24.22v-48.39c-0.09-13.38,10.68-24.3,24.05-24.39
            c0.06,0,0.11,0,0.17,0h24.22v-129h-24.22c-13.38,0-24.22-10.84-24.22-24.22v-48.22c0-13.38,10.84-24.22,24.22-24.22l0,0h129.33
            c13.38,0,24.22,10.84,24.22,24.22l0,0v201.44h24.22c13.38,0,24.22,10.84,24.22,24.22L613.02,734.03z"
          />
        </g>
      </svg>
    </div>
  );
}

export default ToolTipIcon;
